// extracted by mini-css-extract-plugin
module.exports = {"nav__link":"Nav_nav__link__1RTl5","nav__link--active":"Nav_nav__link--active__2dsDW"};